/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createSlice } from '@reduxjs/toolkit';
import { getAllAppsByOrgID, getAllOrgByHistory, getAllOrgsApps } from './orgAppAction';

const initialState = {
    data: {},
    orgAppList: {},
    orgAppHistory: {}
}
const orgAppSlice = createSlice({
    name: 'orgApp',
    initialState,
    extraReducers: {

        [getAllOrgsApps.fulfilled]: (state, { payload }) => {
            state.orgAppList = payload;
        },
        [getAllAppsByOrgID.fulfilled]: (state, { payload }) => {
            state.orgAppList = payload;
        },
        [getAllOrgByHistory.fulfilled]: (state, { payload }) => {
            state.orgAppHistory = payload;
        },
        [getAllOrgByHistory.rejected]: (state, { payload }) => {
            state.orgAppHistory = {};
        },
    }
});

export default orgAppSlice.reducer